/**
 * Format satoshis with comma separators and "sats" suffix
 * @param {number} sats
 * @returns {string} e.g. "14,918 sats"
 */
export function formatSats(sats) {
  if (sats == null) return '—';
  return `${Number(sats).toLocaleString('en-US')} sats`;
}

/**
 * Format USD from cents
 * @param {number} cents
 * @returns {string} e.g. "$10.00"
 */
export function formatUSD(cents) {
  if (cents == null) return '—';
  return `$${(cents / 100).toFixed(2)}`;
}

/**
 * Format an ISO date string to a readable format
 * @param {string} iso
 * @returns {string} e.g. "Mar 31, 2026 12:00 PM"
 */
export function formatDate(iso) {
  if (!iso) return '—';
  const date = new Date(iso);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

/**
 * Format just the date portion
 * @param {string} iso
 * @returns {string} e.g. "Mar 31, 2026"
 */
export function formatDateShort(iso) {
  if (!iso) return '—';
  const date = new Date(iso);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

/**
 * Truncate a transaction ID for display
 * @param {string} txid
 * @param {number} chars - chars to show at each end
 * @returns {string} e.g. "5e3c57...9f6c6"
 */
export function truncateTxId(txid, chars = 6) {
  if (!txid) return '—';
  if (txid.length <= chars * 2 + 3) return txid;
  return `${txid.slice(0, chars)}...${txid.slice(-5)}`;
}

/**
 * Get Liquid testnet block explorer link for a txid
 * @param {string} txid
 * @returns {string}
 */
export function explorerLink(txid) {
  return `https://liquid.network/testnet/tx/${txid}`;
}

/**
 * Format BTC price
 * @param {number} priceUsd
 * @returns {string} e.g. "$67,000"
 */
export function formatBTCPrice(priceUsd) {
  if (priceUsd == null) return '—';
  return `$${Number(priceUsd).toLocaleString('en-US')}`;
}

/**
 * Format a number as a percentage
 * @param {number} value
 * @param {number} decimals
 * @returns {string} e.g. "2.50%"
 */
export function formatPercent(value, decimals = 2) {
  if (value == null) return '—';
  return `${Number(value).toFixed(decimals)}%`;
}
